import axios from 'axios'

import {FETCH_DEPOSITS, FETCH_DEPOSIT, UPDATE_DEPOSIT, DELETE_DEPOSIT, FETCH_VERIFICATIONS} from "./index"
import {toast} from "react-toastify";
import {goBack, push} from "connected-react-router";

export function fetchDeposits() {
  return function (dispatch) {
    dispatch({type: FETCH_DEPOSITS.PENDING});
    axios.get("/deposits?limit=300&sort=-_id")
      .then((response) => {
        dispatch({type: FETCH_DEPOSITS.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: FETCH_DEPOSITS.ERROR, payload: err})
      })
  }
}

export function fetchDeposits2(limit=10, page=1, sort, filter) {
  return function (dispatch) {
    dispatch({type: FETCH_DEPOSITS.PENDING});
    sort = sort.map((item)=>item.desc? '-'+item.id: item.id).join(',')
    filter = filter.map((item)=>item.id + ':'+item.value).join(',')
    console.log(filter)
    axios.get(`/deposits?page=${page}&limit=${limit}&sort=${sort}&filter=${filter}`)
      .then((response) => {
        dispatch({type: FETCH_DEPOSITS.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: FETCH_DEPOSITS.ERROR, payload: err})
      })
  }
}

export function fetchDeposit(depoId) {
  return function (dispatch) {
    dispatch({type: FETCH_DEPOSIT.PENDING});
    axios.get(`/deposits/${depoId}`)
      .then((response) => {
        dispatch({type: FETCH_DEPOSIT.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: FETCH_DEPOSIT.ERROR, payload: err})
      })
  }
}

export function updateDeposit(depoId, new_data) {
  return function (dispatch) {
    dispatch({type: UPDATE_DEPOSIT.PENDING});
    axios.put(`/deposits/${depoId}`, {...new_data})
      .then((response) => {
        dispatch({type: UPDATE_DEPOSIT.SUCCESS, payload: response.data})
        dispatch(goBack())
        toast.success("Deposit updated")
      })
      .catch((err) => {
        dispatch({type: UPDATE_DEPOSIT.ERROR, payload: err})
        toast.error("Deposit update failed")
        toast.error(err.message)
      })
  }
}

export function deleteDeposit(depoId) {
  return function (dispatch) {
    dispatch({type: DELETE_DEPOSIT.PENDING});
    axios.delete(`/deposits/${depoId}`)
      .then((response) => {
        dispatch({type: DELETE_DEPOSIT.SUCCESS, payload: response.data})
        dispatch(push('/deposits'))
        toast.success("Deposit deleted")
      })
      .catch((err) => {
        dispatch({type: DELETE_DEPOSIT.ERROR, payload: err})
        toast.error("Deposit delete failed")
        toast.error(err)
      })
  }
}

export function fetchAllVerifications() {
  return function (dispatch) {
    dispatch({type: FETCH_VERIFICATIONS.PENDING});
    axios.get("/verifications")
      .then((response) => {
        dispatch({type: FETCH_VERIFICATIONS.SUCCESS, payload: response.data});
      })
      .catch((err) => {
        dispatch({type: FETCH_VERIFICATIONS.ERROR, payload: err});
      })
  }
}

export function fetchVerifications(depoId) {
  return function (dispatch) {
    dispatch({type: FETCH_VERIFICATIONS.PENDING});
    axios.get("/deposits/" + depoId + "/verifications")
      .then((response) => {
        dispatch({type: FETCH_VERIFICATIONS.SUCCESS, payload: response.data});
      })
      .catch((err) => {
        dispatch({type: FETCH_VERIFICATIONS.ERROR, payload: err});
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/depositActions.js